module.exports = __webpack_public_path__ + "img/05_kudo_02.3875e227.jpg";